import { Injectable } from '@angular/core';

import { ModalDialogService } from '../../_shared/services/modal-dialog.service';
import { UtilService } from '../../_shared/services/util.service';

import { User } from './user.model';
import { UsersInfoModalComponent } from '../components/users-info-modal/users-info-modal.component';
import { UserInfoModalComponent } from '../components/user-info-modal/user-info-modal.component';

@Injectable({
  providedIn: 'root',
})
export class UserModalService {
  constructor(private modalDialogService: ModalDialogService, private utilService: UtilService) {}

  openUsersInfoModal(users: User[]) {
    const options = {
      width: '650px',
      // height: '100vh',
      panelClass: 'dialog-sidepanel',
      position: { right: '0' },
      data: {
        title: 'USERS',
        obj: users,
      },
      // confirmCallback: successCallback,
      // preventCloseOnSave: true,
    };

    this.modalDialogService.open(options, UsersInfoModalComponent);
  }

  openUserInfoModal(user: User) {
    const options = {
      // width: '650px',
      // height: '100vh',
      panelClass: 'dialog-sidepanel',
      position: { right: '0' },
      data: {
        title: 'USER_DETAILS',
        obj: user,
      },
    };

    this.modalDialogService.open(options, UserInfoModalComponent);
  }
}
